$ = require('jquery')
matchHeight = require('./matchHeight')
scrollbar = require('./scrollbar')

require('../class/wNumb')

module.exports =
	init: ->

		moneyFormat = wNumb(
			thousand: ' '
			postfix: ' Kč'
			decimals: 0
		)

		format = wNumb(
			thousand: ' '
			decimals: 0
		)

		currentAjax = null;

		callAjaxAction = ($this) ->

			if $this.closest('.b-basket-table').length
				$form = $this.closest('form')
				$basket = $('.b-basket')

				if currentAjax && currentAjax.readyState != 4
					currentAjax.abort()

				currentAjax = $.ajax(
					url: $form.attr('action'),
					data: $form.serialize()
				).done((response)->
					$form.html( response.form )
					$basket.html( response.basket )
				)

		$(document)
			# uncheck other checked
			.on('change', '.js-uncheck', (e) ->
				if this.checked
					$('.js-uncheck').not(this).prop('checked', false);
				else
					$('.js-uncheck-null').prop('checked', true);
			)
			# slide boxu
			.on('click', '.link-slide', (e) ->
				e.preventDefault()

				$this = $(this)

				$('body, html').animate(
					scrollTop: $($this.attr('href')).offset().top
				500)
			)
			# menu side a
			.on('click', '.m-side__more a', (e) ->
				e.preventDefault()

				$this = $(@)
				thisHeight = $this.outerHeight()
				$closest = $this.closest('.m-side')
				$items = $closest.find('.m-side__item--hide')

				$closest.addClass('is-active')

				$items.wrapAll('<div class="m-side__wrap"></div>')

				$wrap = $closest.find('.m-side__wrap')
				height = $wrap.height()

				$wrap
					.height(thisHeight)
					.animate(
						height: height
					250)
			)
			# změna ikonky v objednávce
			.on('change', '.b-basket-table__services__item input', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.b-basket-table__services__item')

				if $closest.find('input:checked').length
					$closest.addClass('is-active')
				else
					$closest.removeClass('is-active')
			)

			# inp count
			.on('click touchend', '.inp__count-tool', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.inp__count')
				$input = $closest.find('input')

				$input.val( format.to( Number( Number( $input.val().replace(' ', '') ) * 1 + $this.data('step') ) ) )

				if $input.val() < 1
					$input.val( $closest.find('.inp__count-tool--plus').data('step') )

				if $this.closest('.f-voucher').length
					$('.b-voucher__value').text( moneyFormat.to( Number( $input.val().replace(' ', '') ) ) )

				callAjaxAction($this)


			)

			# ajax response on changing protection
			.on('change', 'input[name*="protect"]', (e) ->

				$this = $(@)

				callAjaxAction($this)

			)

			# ajax response on changing discount code
			.on('keyup', 'input[name*="discount"]', (e) ->

				$this = $(@)
				$form = $this.closest('form')

				$form.submit ->
					return false

				if e.keyCode == 13
					callAjaxAction($this)
			)

			.on('click', '.js-discount', (e) ->
				e.preventDefault()
				$this = $(@)

				callAjaxAction($this)
			)


			# basket remove
			.on('click touchend', '.b-basket-table__remove', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.b-basket-table__item')
				$all = $('.b-basket-table')
				$sum = $('.b-basket-table__sum .b-basket-table__sum__r')
				$accessories = $('.c-accessories').closest('.b-default')
				$basket = $('.b-basket')

				$.ajax(
					url: $this.attr('href')
				).done((response)->
					if $(response.sum).hasClass('b-basket-table__sum__r')
						$sum.replaceWith(response.sum)
					else
						$all.html(response.sum)

					if response.accessories
						$accessories.find('.c-accessories').html( $(response.accessories).find('.c-accessories').html() )
					else
						$accessories.remove()

					$basket.html( response.basket )

					matchHeight.init({$target:$accessories})
					scrollbar.init({$target:$accessories})
				)

				$closest.animate(
					opacity: 0
				, 500, ->
					$closest.slideUp(->
						$closest.remove()
					)
				)
			)
			# form transporm payment
			.on('change changeInit', '.f-transport-payment__list--transport .f-transport-payment__inner input', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.f-transport-payment__list')
				$items = $closest.find('.f-transport-payment__item')
				$item = $(".f-transport-payment__list--payment li")
				id = $("." + $this.attr("value"))

				# subitems
				$items
					.removeClass('is-active')
					.filter( $this.closest('.f-transport-payment__item') )
						.addClass('is-active')

				# payment
				if event.type isnt "changeInit" or (event.type is "changeInit" and $this.is(":checked"))
					$item.hide()
					$item.filter(id).show()
			)
			# form open
			.on('change', '.f-open__inp', ->
				$this = $(@)
				$closest = $this.closest('.f-open')
				$box = $closest.find('.f-open__box')

				if $this.is(':checked')
					$box.slideDown()
				else
					$box.slideUp()
			)
			# mobile menu
			# .on('click touchend', '.m-main__toggle', (e) ->
			# 	e.preventDefault()

			# 	$(@).closest('.m-main__item').toggleClass('is-open')
			# )
			.on('click touchend', '.m-main__mobile__toggle', (e) ->
				e.preventDefault()

				$(@).closest('.m-main').toggleClass('is-open')
			)
			# mobile search
			.on('focus', '.f-search__input', (e) ->
				e.preventDefault()

				$(@).closest('.f-search').addClass('is-active')
			)
			.on('blur', '.f-search__input', (e) ->
				e.preventDefault()

				$(@).closest('.f-search').removeClass('is-active')
			)
			# menu tablet
			# .on('click touchend', '.m-main__item--submenu > .m-main__link', (e) ->
			# 	if $(window).width() > 750
			# 		e.preventDefault()

			# 		$(@).parent().toggleClass('is-hover')
			# )
			# .on('click touchend', (e) ->
			# 	if not $(e.target).closest('.m-main__item--submenu').length
			# 		$('.m-main__item--submenu').removeClass('is-hover')
			# )
			# btn function
			.on('click', '.b-functions .btn', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.b-functions')
				$box = $closest.find('.b-functions__text')
				$text = $this.find('.btn__text')
				$textBtn = '<span class="btn__icon"><span class="icon icon--add"></span></span>' + $this.data('hide-text')
				$newTextBtn = '<span class="btn__icon"><span class="icon icon--minus"></span></span>' + $this.data('show-text')

				$box.toggleClass('is-active')

				if $box.hasClass('is-active')
					$box.animate({height: $box.prop('scrollHeight')})
					$text.html($newTextBtn)
				else
					$box.animate({height: 120})
					$text.html($textBtn)
			)
			# btn gallery
			.on('click', '.b-blog-gallery__btn .btn', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.b-blog-gallery')
				$box = $closest.find('.b-blog-gallery__list')
				$items = $closest.find('.b-blog-gallery__item')
				$text = $this.find('.btn__text')
				$textBtn = '<span class="btn__icon"><span class="icon icon--add"></span></span>' + $this.data('hide-text')
				$newTextBtn = '<span class="btn__icon"><span class="icon icon--minus"></span></span>' + $this.data('show-text')

				$box.toggleClass('is-active')

				if $box.hasClass('is-active')
					$box.animate({height: $box.prop('scrollHeight')})
					$text.html($newTextBtn)
				else
					$box.animate({height: $items.height()*2})
					$text.html($textBtn)
			)
			# trigger click -> window.location
			.on('click', '.c-accessories__inner', (e) ->
				$this = $(@)

				if !$(e.target).is('a') and $(e.target).closest('a').length < 1 and $(e.target).closest('button').length < 1
					window.location = $this.find('.c-accessories__link').attr('href')
			)
			.on('click', '.c-recommendations__inner', (e) ->
				$this = $(@)

				if !$(e.target).is('a') and $(e.target).closest('a').length < 1
					window.location = $this.find('.c-recommendations__link').attr('href')
			)
			.on('click', '.c-products__inner', (e) ->
				$this = $(@)

				if !$(e.target).is('a') and $(e.target).closest('a').length < 1
					window.location = $this.find('.c-products__link').attr('href')
			)
			# fancy box small images help
			.on('click', '.b-product__images-s-item', (e) ->
				e.preventDefault()

				$('.b-product__images-m .fancybox').eq( $(this).index() + 1 ).trigger('click')
			)
			# comments link
			.on('click', '.b-comments__link .link', (e) ->
				e.preventDefault()

				$this = $(@)
				$closest = $this.closest('.b-comments__content, .b-comments__specialist')

				if $this.data('success')
					$closest.next('.b-comments__form').toggle()
				else
					$this.data('success', true)

					$.ajax(
						url: $this.attr('href')
					)
					.done( (response) ->
						$closest.after(response)
					)
			)
			.on('click', '.b-comments__form__close', (e) ->
				e.preventDefault()

				$(@).closest('.b-comments__form').hide()
			)
			# share
			.on('click', '.b-compare__header__link--share', (e) ->
				e.preventDefault()

				$(@).closest('.b-compare__header__links').addClass('is-active')
			)
			.on('click', (event) ->
				if not $(event.target).closest('.b-compare__header__links').length
					$('.b-compare__header__links').removeClass('is-active')
			)
			.on('click', '.f-transport-payment__subitem .inp__item', (e) ->
				#e.preventDefault()

				$this = $(@)
				$otherItems = $('.f-transport-payment__subitem .inp__item').not($this)

				$this.find('.f-transport-payment__show-map').hide()
				$otherItems.find('.f-transport-payment__show-map').show()

				# $this.find('.f-transport-payment__map').show()
				# $otherItems.find('.f-transport-payment__map').hide()
			)
			.on('click focus', '.f-variants__inner input', (e) ->
				e.preventDefault()

				$this = $(@)
				$label = $this.closest('label')
				$button = $label.find('input[type="radio"]')

				$button.prop('checked', true)
			)
			.on('click', '.f-variants__wrap--custom', (e) ->
				$this = $(@)
				$input = $this.find('input')

				$input.trigger('focus')

				changeVoucherValue($this.find('.js-custom-value').val())
			)
			# zmena castky voucheru
			.on('change', '.f-variants__item input[type="radio"]', (e) ->
				$this = $(@)

				changeVoucherValue($this.val())
			)
			.on('keyup', '.js-custom-value', (e) ->
				$this = $(@)

				changeVoucherValue($this.val())
			)
			# cookie AJAX
			.on('click', '.ajax-cookie', (e) ->
				e.preventDefault()

				$this = $(@)

				$.ajax(
					url: $this.attr('href')
				)

				$('.b-cookie').fadeOut();
			)
			# availability form
			.on('submit', '.f-availability', (e) ->
				e.preventDefault()

				$this = $(@)
				$response = $this.find('.f-availability__response')

				$.ajax(
					url: $this.attr('action')
					data: $this.serialize()
					beforeSend: ->
						$('body').addClass('show-loader')
				)
				.done( (response) ->
					$('body').removeClass('show-loader')
					$response.html(response)
				)

				$('.b-cookie').fadeOut();
			)

		# transport trigger
		$('.f-transport-payment__item--transport input:checked').trigger('changeInit')

		# order side panel
		$('.b-order__side').each(->
			$orderSide = $(@)
			orderSideTop = $orderSide.offset().top
			$(window)
				.on('scroll', ->
					if $(document).scrollTop() > orderSideTop
						$orderSide.addClass('is-fixed')
					else
						$orderSide.removeClass('is-fixed')
				)
		)
		$('.b-compare').each(->
			$this = $(@)
			$list = $this.find('.b-compare__list')
			$menu = $this.find('.b-compare__menu__list')
			orderSideTop = $this.offset().top

			$list
				.on('scroll', ->
					$menu.scrollLeft( $list.scrollLeft() )
				)
			$menu
				.on('scroll', ->
					$list.scrollLeft( $menu.scrollLeft() )
				)

			$(window)
				.on('scroll', ->
					if $(document).scrollTop() > orderSideTop
						$this.find('.b-compare__menu').addClass('is-fixed')
					else
						$this.find('.b-compare__menu').removeClass('is-fixed')
				)
		)

		# gallery fix
		$(window).on('load', ->
			$('.b-blog-gallery__list').each(->
				$this = $(@)
				$items = $this.find('.b-blog-gallery__item')
				coef = 1

				if $items.length > 3
					coef = 2

				$this.css({
					height: $items.height() * coef
				})
			)
		)

		# focus input
		$('.inp--focus').focus()

		changeVoucherValue =(value) ->
			number = Number(value.replace(' ', ''))
			voucherProdID = $('.js-voucher-productId')
			prodID = $('.f-variants input[type=radio]:checked').data('prod-id')

			if number
				$('.f-buy [name="price"]').val(number)

				$.ajax({
					method: 'GET',
					url: $('.f-variants').data('php-url'),
					data: { price: number, prod_id: prodID },
					dataType: 'json',
					success: (data) ->
						priceWithTax = data['price']
						priceWithoutTax = data['priceWithoutVAT']

						if priceWithoutTax
							$('.js-voucher-value').text(priceWithTax)
						if priceWithoutTax
							$('.js-voucher-value-without-tax').text(priceWithoutTax)

						voucherProdID.val(data['productId'])
				});



// WEBPACK FOOTER //
// ./src/js/components/eventActions.coffee